module.exports = __webpack_public_path__ + "img/ys1.e8708254.jpg";